import React from 'react'
import { CHART_COLORS } from '../types'

interface BarChartData {
  label: string
  value: number
  color?: string
}

interface BarChartProps {
  data: BarChartData[]
  title?: string
  height?: number
  formatValue?: (value: number) => string
  maxBars?: number
}

export const BarChart: React.FC<BarChartProps> = ({
  data,
  title,
  height = 300,
  formatValue = (value) => value.toString(),
  maxBars = 10
}) => {
  if (data.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        {title && (
          <h3 style={{ 
            fontSize: '16px', 
            fontWeight: '600', 
            color: '#111827',
            fontFamily: 'Lexend Deca, sans-serif',
            marginBottom: '16px'
          }}>
            {title}
          </h3>
        )}
        <p style={{ color: '#6b7280', fontFamily: 'Lexend Deca, sans-serif' }}>
          No data to display
        </p>
      </div>
    )
  }

  const displayData = data.slice(0, maxBars)
  const maxValue = Math.max(...displayData.map(item => item.value))
  const chartHeight = height - 60 // Leave space for labels

  return (
    <div>
      {title && (
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: '600', 
          color: '#111827',
          fontFamily: 'Lexend Deca, sans-serif',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          {title}
        </h3>
      )}
      
      <div style={{ 
        display: 'flex',
        alignItems: 'end',
        height: `${height}px`,
        padding: '20px',
        gap: '8px',
        background: 'white',
        borderRadius: '8px',
        border: '1px solid #e5e7eb'
      }}>
        {displayData.map((item, index) => {
          const barHeight = maxValue > 0 ? (item.value / maxValue) * chartHeight : 0
          const color = item.color || CHART_COLORS[index % CHART_COLORS.length]
          
          return (
            <div
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                flex: 1,
                minWidth: '60px'
              }}
            >
              <div
                style={{
                  width: '100%',
                  maxWidth: '50px',
                  height: `${barHeight}px`,
                  backgroundColor: color,
                  borderRadius: '4px 4px 0 0',
                  minHeight: '2px',
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  paddingTop: '4px'
                }}
              >
                <span style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: 'white',
                  textAlign: 'center',
                  wordBreak: 'break-all',
                  lineHeight: '1.2'
                }}>
                  {formatValue(item.value)}
                </span>
              </div>
              
              <div style={{
                marginTop: '8px',
                fontSize: '12px',
                color: '#6b7280',
                textAlign: 'center',
                fontFamily: 'Lexend Deca, sans-serif',
                wordBreak: 'break-word',
                maxWidth: '60px',
                lineHeight: '1.2'
              }}>
                {item.label.length > 12 ? `${item.label.substring(0, 10)}...` : item.label}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}